var Ctx = /*#__PURE__*/function () {
  function Ctx(React, Babel) {
    this._temp = '';
    this._parentTemp = "\"use strict\";\nreturn @temp;";
    this._com = function () {
      return null;
    };
    if (typeof window === 'object') {
      window.React = window.React || React;
    }
    if (!Babel) {
      throw new Error("Package \"string-to-react-component\" has a missing peer dependency of \"@babel/standalone\" ( requires \"^7.23.10\" )");
    }
    this._getBabel = function () {
      return Babel;
    };
  }
  var _proto = Ctx.prototype;
  _proto._checkBabelOptions = function _checkBabelOptions(babelOptions) {
    if (Object.prototype.toString.call(babelOptions) !== '[object Object]') {
      throw new Error("babelOptions prop of string-to-react-component element should be an object.");
    }
    if (Object.prototype.hasOwnProperty.call(babelOptions, 'presets') === false) {
      babelOptions.presets = ['react'];
    } else {
      var _babelOptions$presets;
      //check if babelOptions.presets is not type of Array
      if (!(typeof babelOptions.presets === 'object' && ((_babelOptions$presets = babelOptions.presets) == null ? void 0 : _babelOptions$presets.constructor) == Array)) {
        throw new Error("string-to-react-component Error : presets property of babelOptions prop should be an array");
      }
      if (babelOptions.presets.indexOf('react') === -1) {
        babelOptions.presets.push('react');
      }
    }
  };
  _proto._transpile = function _transpile(babelOptions) {
    // make sure react presets is registered in babelOptions
    this._checkBabelOptions(babelOptions);
    var resultObj = this._getBabel().transform(this._temp, babelOptions);
    var filename = babelOptions.filename;
    var code = resultObj.code;
    if (filename) {
      code = resultObj.code + ("\n//# sourceURL=" + filename);
    }
    return code || 'null';
  };
  _proto._generateCom = function _generateCom(babelOptions) {
    this._com = Function(this._parentTemp.replace('@temp', this._transpile(babelOptions)))();
    this._validateCodeInsideTheTemp();
  };
  _proto._validateCodeInsideTheTemp = function _validateCodeInsideTheTemp() {
    if (typeof this._com !== 'function') {
      throw new Error("code inside the passed string into string-to-react-component, should be a function");
    }
  };
  _proto._validateTemplate = function _validateTemplate(temp) {
    if (typeof temp !== 'string') {
      throw new Error("passed child into string-to-react-component element should b a string");
    }
    if (temp === '') {
      throw new Error("passed string into string-to-react-component element can not be empty");
    }
  };
  _proto.updateTemplate = function updateTemplate(template, babelOptions) {
    this._validateTemplate(template);
    if (template !== this._temp) {
      this._temp = template;
      this._generateCom(babelOptions);
    }
    return this;
  };
  _proto.getComponent = function getComponent() {
    return this._com;
  };
  return Ctx;
}();
export default Ctx;